var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281.266,
    height: 50.975,
    viewBox: "0 0 281.266 50.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.085,
    y1: 1.055,
    x2: 1.012,
    y2: 0.194,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#211e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2e1f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#422228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5f2630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#852a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#b23049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e73758"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PROY_APUESTES_BrandPack_01",
    transform: "translate(-35.95 -33.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1447",
    "data-name": "Trazado 1447",
    d: "M94.15,44.449a.277.277,0,0,1,0-.055,10.91,10.91,0,1,1,10.907,10.958h-.022A10.91,10.91,0,0,1,94.15,44.5a.331.331,0,0,1,0-.055Zm-29.1,0a10.909,10.909,0,1,1,21.818-.128h0v.256h0a18.164,18.164,0,0,0,17.854,18.051h.7a10.907,10.907,0,1,1-11.25,10.958c0-.022,0-.168,0-.19a18.128,18.128,0,0,0-3.653-10.808,18.431,18.431,0,0,0-3.536-3.558.486.486,0,0,1-.069-.051,18.113,18.113,0,0,0-10.592-3.653h-.679a18.135,18.135,0,0,0-10.592,3.653A18.332,18.332,0,0,0,61.43,62.6a18.131,18.131,0,0,0-3.653,10.925h0a10.914,10.914,0,1,1-11.257-10.9h.69A18.113,18.113,0,0,0,57.8,58.975a18.351,18.351,0,0,0,3.616-3.62,18.142,18.142,0,0,0,3.653-10.921h0",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1448",
    "data-name": "Trazado 1448",
    d: "M290.33,67.867c0-6.293,4.774-11.067,10.392-11.067a9.174,9.174,0,0,1,6.845,2.743v-2.3h6.75V78.361h-6.757V75.91a8.8,8.8,0,0,1-6.717,2.871A10.686,10.686,0,0,1,290.33,67.867Zm6.549-.037a5.353,5.353,0,1,0,10.687,0,5.355,5.355,0,1,0-10.687,0Z",
    transform: "translate(-161.466 -14.805)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1449",
    "data-name": "Trazado 1449",
    d: "M374.577,57.27v2.367a9.185,9.185,0,0,1,6.841-2.787c5.621,0,10.392,4.774,10.392,11.067a10.657,10.657,0,0,1-10.516,10.9,8.949,8.949,0,0,1-6.717-2.871v10.9H367.82V57.27Zm5.362,16.247a5.67,5.67,0,0,0,0-11.319,5.491,5.491,0,0,0-5.362,5.665A5.43,5.43,0,0,0,379.939,73.517Z",
    transform: "translate(-210.652 -14.837)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1450",
    "data-name": "Trazado 1450",
    d: "M442.87,69.261V58h6.757V68.669c0,3.127,1.647,5.154,4.383,5.154,3,0,4.774-2.407,4.774-5.479V58h6.779V79.123h-6.757V76.738a8.3,8.3,0,0,1-6.505,2.875C446.712,79.612,442.87,75.934,442.87,69.261Z",
    transform: "translate(-258.29 -15.567)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1451",
    "data-name": "Trazado 1451",
    d: "M526.469,56.57c7.561,0,11.407,5.534,11.067,12.247H521.991a5.107,5.107,0,0,0,5.154,4.774,6.015,6.015,0,0,0,5.322-2.7l4.058,2.831c-1.461,2.491-4.9,4.986-9.928,4.986-6.8,0-11.447-4.9-11.447-11.067S519.288,56.57,526.469,56.57Zm4.986,8.489a4.217,4.217,0,0,0-4.438-3.674,4.748,4.748,0,0,0-4.814,3.674Z",
    transform: "translate(-304.169 -14.659)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1452",
    "data-name": "Trazado 1452",
    d: "M585.029,72.112a10.909,10.909,0,0,0,6.505,1.735c1.461,0,2.747-.676,2.747-1.647,0-3-11.451-2.411-11.451-9.212,0-4.018,3.59-6.418,9.168-6.418a14.678,14.678,0,0,1,8.109,2.027L597.827,62.9a10.5,10.5,0,0,0-5.577-1.519c-1.1,0-2.787.252-2.787,1.461,0,2.747,11.575,2.491,11.575,9.292,0,4.1-3.846,6.549-9.548,6.549-5.618,0-8.036-1.775-9.04-2.495Z",
    transform: "translate(-346.887 -14.659)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1453",
    "data-name": "Trazado 1453",
    d: "M638.77,53.837V48.574h2.875V43.15H648.4v5.424h4.858v5.263H648.4v8.28c0,1.859.464,2.831,2.027,2.831a8.127,8.127,0,0,0,2.579-.468l1.267,4.774a14.923,14.923,0,0,1-5.366.888c-5.746,0-7.265-3.251-7.265-7.985V53.837Z",
    transform: "translate(-382.636 -6.141)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1454",
    "data-name": "Trazado 1454",
    d: "M699.123,56.57c7.561,0,11.4,5.534,11.067,12.247H694.645a5.1,5.1,0,0,0,5.154,4.774,6.015,6.015,0,0,0,5.322-2.7l4.054,2.831c-1.461,2.491-4.9,4.986-9.924,4.986-6.8,0-11.451-4.9-11.451-11.067S691.942,56.57,699.123,56.57Zm4.986,8.489a4.222,4.222,0,0,0-4.438-3.674,4.748,4.748,0,0,0-4.814,3.674Z",
    transform: "translate(-413.757 -14.659)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1455",
    "data-name": "Trazado 1455",
    d: "M757.689,72.112a10.9,10.9,0,0,0,6.505,1.735c1.461,0,2.743-.676,2.743-1.647,0-3-11.447-2.411-11.447-9.212,0-4.018,3.591-6.418,9.168-6.418a14.689,14.689,0,0,1,8.109,2.027L770.487,62.9a10.5,10.5,0,0,0-5.577-1.519c-1.1,0-2.787.252-2.787,1.461,0,2.747,11.575,2.491,11.575,9.292,0,4.1-3.846,6.549-9.548,6.549-5.618,0-8.036-1.775-9.04-2.495Z",
    transform: "translate(-456.482 -14.659)",
    fill: "#1d1e1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1456",
    "data-name": "Trazado 1456",
    d: "M517.3,138.86h3.6a2.37,2.37,0,0,1,2.528,2.743,3.287,3.287,0,0,1-3.287,2.743h-2.67l-.468,3.364h-.946Zm.833.822-.544,3.843H520a2.224,2.224,0,0,0,2.476-1.921c.179-1.227-.555-1.921-1.932-1.921Z",
    transform: "translate(-304.747 -66.892)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1457",
    "data-name": "Trazado 1457",
    d: "M537.618,148.714a3.89,3.89,0,0,1,3.755-3.287,2.78,2.78,0,0,1,2.831,3.287A3.894,3.894,0,0,1,540.449,152a2.78,2.78,0,0,1-2.831-3.287Zm2.922,2.531a2.962,2.962,0,0,0,2.754-2.531,2.107,2.107,0,0,0-2.045-2.528,2.969,2.969,0,0,0-2.758,2.528,2.119,2.119,0,0,0,2.06,2.531Z",
    transform: "translate(-318.401 -71.06)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1458",
    "data-name": "Trazado 1458",
    d: "M560.744,145.78l1.187,5.114,2.619-5.114h.972l1.191,5.114,2.615-5.114h.975L566.99,152.1h-.9l-1.227-5.059-2.655,5.059h-.888l-1.541-6.323Z",
    transform: "translate(-332.498 -71.285)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1459",
    "data-name": "Trazado 1459",
    d: "M594.046,145.43c1.972,0,3.032,1.366,2.677,3.441H591.15a2.023,2.023,0,0,0,2.009,2.378,2.831,2.831,0,0,0,2.316-1.2l.643.365a3.594,3.594,0,0,1-3.072,1.607,2.748,2.748,0,0,1-2.743-3.287A3.861,3.861,0,0,1,594.046,145.43Zm1.855,2.681a1.782,1.782,0,0,0-1.947-1.921,2.758,2.758,0,0,0-2.641,1.921Z",
    transform: "translate(-351.851 -71.063)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1460",
    "data-name": "Trazado 1460",
    d: "M613.768,145.558l-.139,1a3.5,3.5,0,0,1,2.557-1.129,5.022,5.022,0,0,1,.617.051l-.329.822a2.194,2.194,0,0,0-.416-.037,2.648,2.648,0,0,0-2.707,2.25l-.468,3.364H612l.884-6.323Z",
    transform: "translate(-365.644 -71.063)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1461",
    "data-name": "Trazado 1461",
    d: "M634.045,145.78h.971l2.06,5.274,2.812-5.274h.972L636.926,153a2.974,2.974,0,0,1-2.579,1.757,2.224,2.224,0,0,1-1.428-.519l.365-.632a1.932,1.932,0,0,0,1.125.405,2.081,2.081,0,0,0,1.782-1.3l.329-.6Z",
    transform: "translate(-378.922 -71.285)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1462",
    "data-name": "Trazado 1462",
    d: "M655.919,148.714a3.894,3.894,0,0,1,3.755-3.287,2.78,2.78,0,0,1,2.831,3.287A3.894,3.894,0,0,1,658.75,152a2.783,2.783,0,0,1-2.831-3.287Zm2.922,2.531a2.959,2.959,0,0,0,2.758-2.531,2.112,2.112,0,0,0-2.049-2.528,2.966,2.966,0,0,0-2.758,2.528,2.129,2.129,0,0,0,2.075,2.531Z",
    transform: "translate(-393.492 -71.06)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1463",
    "data-name": "Trazado 1463",
    d: "M678.737,149.257l.482-3.477h.884l-.482,3.477c-.19,1.351.42,2.213,1.644,2.213A2.59,2.59,0,0,0,683.8,149.2l.479-3.415h.888l-.88,6.323H683.4l.139-1.012a2.922,2.922,0,0,1-2.363,1.14C679.317,152.23,678.47,151.08,678.737,149.257Z",
    transform: "translate(-407.974 -71.285)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1464",
    "data-name": "Trazado 1464",
    d: "M701.988,145.558l-.139,1a3.5,3.5,0,0,1,2.557-1.129,5.024,5.024,0,0,1,.617.051l-.329.822a2.194,2.194,0,0,0-.416-.037,2.648,2.648,0,0,0-2.707,2.25l-.468,3.364h-.884l.884-6.323Z",
    transform: "translate(-421.641 -71.063)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1465",
    "data-name": "Trazado 1465",
    d: "M723.648,148.714a3.89,3.89,0,0,1,3.755-3.287,2.78,2.78,0,0,1,2.831,3.287A3.9,3.9,0,0,1,726.479,152a2.78,2.78,0,0,1-2.831-3.287Zm2.922,2.531a2.962,2.962,0,0,0,2.754-2.531,2.106,2.106,0,0,0-2.045-2.528,2.969,2.969,0,0,0-2.758,2.528,2.119,2.119,0,0,0,2.06,2.531Z",
    transform: "translate(-436.482 -71.06)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1466",
    "data-name": "Trazado 1466",
    d: "M745.863,144.517a3.883,3.883,0,0,1,3.755-3.287,2.465,2.465,0,0,1,2.239,1.191l.5-3.59h.888l-1.242,8.85h-.884l.139-1.074a3.375,3.375,0,0,1-2.579,1.2A2.77,2.77,0,0,1,745.863,144.517Zm2.922,2.557a2.987,2.987,0,0,0,2.758-2.557A2.091,2.091,0,0,0,749.494,142a2.976,2.976,0,0,0-2.758,2.517,2.134,2.134,0,0,0,2.078,2.542Z",
    transform: "translate(-450.592 -66.873)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1467",
    "data-name": "Trazado 1467",
    d: "M769.065,144.517a3.883,3.883,0,0,1,3.755-3.287,2.466,2.466,0,0,1,2.239,1.191l.5-3.59h.888l-1.231,8.861h-.884l.139-1.074a3.375,3.375,0,0,1-2.579,1.2,2.783,2.783,0,0,1-2.831-3.3Zm2.922,2.557a2.984,2.984,0,0,0,2.758-2.557A2.091,2.091,0,0,0,772.7,142a2.976,2.976,0,0,0-2.758,2.517,2.131,2.131,0,0,0,2.06,2.542Z",
    transform: "translate(-465.309 -66.873)",
    fill: "#e73758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1468",
    "data-name": "Trazado 1468",
    d: "M791.43,150.6a2.4,2.4,0,0,0,1.826.647c.946,0,1.695-.405,1.782-1.012.19-1.377-3.894-.909-3.58-3.148.153-1.063,1.176-1.658,2.67-1.658a3.231,3.231,0,0,1,2.111.584l-.457.657a2.791,2.791,0,0,0-1.618-.482c-.581,0-1.706.113-1.826.9-.2,1.49,3.883.961,3.58,3.123-.15,1.1-1.213,1.8-2.805,1.8a2.976,2.976,0,0,1-2.254-.731Z",
    transform: "translate(-479.174 -71.063)",
    fill: "#e73758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dba547bda5e3c936dd8a1208210365ad.svg";
export { ForwardRef as ReactComponent };